import {getUpdateOrg} from '../reducers/state';
import {makeEditOrgModal} from './configEditOrgRequests';
import {UPDATE_ORG_PREFIX} from './state';


export const {
  /** @type {ReduxRequestModal} */
  requestModal: updateOrgRequestModal,
} = makeEditOrgModal({
  prefix: UPDATE_ORG_PREFIX,
  getState: getUpdateOrg,
});



// WEBPACK FOOTER //
// ./src/js/organizations/redux/updateOrg.js